import { heroData } from "@/mocks/manga";

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20fantasy%20magical%20worldscape%20with%20a%20glowing%20golden%20gateway%20portal%20among%20floating%20islands%20and%20ancient%20mystic%20books%2C%20warm%20amber%20and%20gold%20glow%2C%20ethereal%20particles%2C%20deep%20ink%20charcoal%20sky%2C%20epic%20magic%20adventure%20atmosphere%2C%20cinematic%20digital%20illustration%2C%20high%20detail&width=1600&height=900&seq=qm-hero-bg-01&orientation=landscape"
          alt="奇妙漫画异世界奇幻魔法冒险背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/70 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pt-36 md:pt-44 pb-20 text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-4 py-1.5 text-sm text-primary-400">
          <i className="ri-sparkling-2-line"></i>
          {heroData.tag}
        </span>

        <h1 className="mt-6 font-heading text-4xl font-black leading-tight tracking-wide text-foreground-950 md:text-6xl">
          {heroData.title}
        </h1>
        <p className="mt-3 font-heading text-lg font-semibold text-primary-500 md:text-2xl">
          {heroData.subtitle}
        </p>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          {heroData.slogan}
        </p>

        <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#latest"
            className="w-full rounded-full bg-primary-500 px-8 py-3 text-base font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap sm:w-auto"
          >
            开始追漫
          </a>
          <a
            href="#ranking"
            className="w-full rounded-full border border-background-300 bg-background-100/80 px-8 py-3 text-base font-medium text-foreground-950 transition-colors hover:border-primary-500 hover:text-primary-500 whitespace-nowrap sm:w-auto"
          >
            查看人气榜单
          </a>
        </div>

        <div className="mt-14 grid w-full grid-cols-2 gap-4 md:grid-cols-4">
          {heroData.stats.map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-background-200/70 bg-background-100/60 px-4 py-5 backdrop-blur"
            >
              <p className="font-heading text-2xl font-bold text-primary-500 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-sm text-foreground-700">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}